/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Footer({ light }) {
  return (
    <MDBox position="absolute" width="100%" bottom={0} py={2}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          color={light ? "white" : "text"}
        >
          <MDTypography variant="button" fontWeight="regular" color={light ? "white" : "dark"}>
            made with&nbsp;
            <Icon fontSize="inherit" sx={{ verticalAlign: "middle" }}>
              favorite
            </Icon>
            &nbsp;by&nbsp;
            <Link href="https://www.solv-it.dev" target="_blank" underline="none">
              <strong>LOOPBOX</strong>
            </Link>
          </MDTypography>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
